var $ = require('jquery');
var slick = require('@accessible360/accessible-slick');

module.exports = {
	init: function () {
		var slider = $('.layout.media-slider .media-slider-items-inner');
		if (slider.length > 0) {
			// Only number the region labels when a page holds more than one media carousel
			var numberRegions = slider.length > 1;
			for (var i = 0; i < slider.length; i++) {
				var $currentSlider = $(slider[i]);
				var $sliderContainer = $currentSlider.closest('.media-slider-items-inner');
				var $sliderControls = $sliderContainer.parent().find('.slider-controls');
				var $slideCounter = $sliderContainer.find('.slide').length;
				var showArrows = $slideCounter > 1;
				var initialSlide = !showArrows || $slideCounter == 2 ? 0 : 1;
				var prevArrow = showArrows ? $sliderControls.find('.slick-prev') : null;
				var nextArrow = showArrows ? $sliderControls.find('.slick-next') : null;
				var regionLabel = numberRegions ? 'Media carousel ' + (i + 1) : 'Media carousel';
				// remove slider controls if only one slide
				if (!showArrows) {
					$sliderControls.remove();
				}

				// Toggle some classes to create the center mode circular effect
				$currentSlider.on('init', function (event, slick) {
					$('.slick-current').prev().addClass('prev-slide');
					$('.slick-current').next().addClass('next-slide');
				});
				$currentSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
					$('.slick-slide').removeClass('prev-slide next-slide');
				});
				$currentSlider.on('afterChange', function (event, slick, currentSlide) {
					// Add classes after the slide has changed
					$('.slick-current').prev().addClass('prev-slide');
					$('.slick-current').next().addClass('next-slide');
				});
				// Init slider with responsive settings
				$currentSlider.slick({
					dots: true,
					infinite: false,
					initialSlide: initialSlide,
					arrows: showArrows,
					centerMode: true,
					speed: 500,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerPadding: '190px',
					appendDots: $sliderControls.find('.slick-dots-wrapper'),
					prevArrow: prevArrow,
					nextArrow: nextArrow,
					regionLabel: regionLabel,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								centerPadding: '100px',
							},
						},
						{
							breakpoint: 640,
							settings: {
								centerPadding: '50px',
							},
						},
						{
							breakpoint: 480,
							settings: {
								centerPadding: '0px',
								centerMode: false,
							},
						},
					],
				});

				// Slick puts role="region" on the slider element itself, so move the controls
				// inside it for the region to encapsulate the prev/next buttons and the dots
				if (showArrows) {
					$currentSlider.append($sliderControls);
				}
			}
		}
	},
};
